// apps/customer-ui/src/app/core/services/error-handler.service.ts

import { inject, Injectable } from '@angular/core';
import {
  BaseErrorHandlerService,
  ErrorData,
  ErrorStorageService,
} from '@awo-care/shared-core';
import { UserService } from './user.service';
import { versionCustomer } from 'package.json';
import { environment } from '@awo-care/shared-auth';

@Injectable({ providedIn: 'root' })
export class CustomerErrorHandlerService extends BaseErrorHandlerService {
  private userService = inject(UserService);
  private errorStorage = inject(ErrorStorageService);

  getUserId(): string {
    return this.userService.currentUser()?.uid || 'unknown';
  }

  getUserEmail(): string {
    return this.userService.currentUser()?.email || 'unknown';
  }

  getAppVersion(): string {
    return versionCustomer;
  }

  getEnvironment(): string {
    return environment.tier || 'unknown';
  }

  getAppType(): 'customer' | 'employee' {
    return 'customer';
  }

  protected async processError(
    sendErrorData: ErrorData,
    errorData: GlobalError
  ): Promise<void> {
    switch (errorData.bugReport) {
      case 'auto':
        await this.errorStorage.storeError(sendErrorData);
        break;
      case 'manual':
        this.showErrorSnackbar(errorData);
        break;
      case 'none':
        break;
      default:
        if (this.getEnvironment() === 'PROD') {
          await this.errorStorage.storeError(sendErrorData);
        }
        break;
    }
  }
}
